import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const OpenInternalIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 25)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="2"
    >
      <path
        d="m10.29 15 7.55-7.52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(-684 -371)">
        <path
          d="m697.05 377.32h6v6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect height="23" rx="2" width="23" x="685" y="372" />
      </g>
    </SVG>
  );
};
